import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { ComprehensiveProcessNotifications } from '@content/home/comprehensive-process-notifications/comprehensive-process-notifications.type';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { NgOptimizedImage } from '@angular/common';
import { ContactAndPlansButtonsComponent } from '@shared/contact-and-plans/contact-and-plans-buttons.component';
import { AvatarWithMessageComponent } from '@shared/avatar-with-message/avatar-with-message.component';
import { AvatarSubtitle, AvatarTitle, RotatePosition } from '@shared/avatar-with-message/avatar-with-message.constants';

@Component({
    selector: 'companyid-comprehensive-process-notifications',
    imports: [
        ContentWrapperComponent,
        AssetPipe,
        NgOptimizedImage,
        ContactAndPlansButtonsComponent,
        AvatarWithMessageComponent,
    ],
    templateUrl: './comprehensive-process-notifications.component.html',
    styleUrl: './comprehensive-process-notifications.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComprehensiveProcessNotificationsComponent {
    public readonly avatarTitle = AvatarTitle.HI_I_AM_A;
    public readonly avatarSubtitle = AvatarSubtitle.PROJECT_MANAGER;
    public readonly avatarPosition = RotatePosition.EIGHT_DEG;

    public readonly comprehensiveContent: ComprehensiveProcessNotifications[] = [
        {
            imgPath: 'notification',
            title: $localize`:@@comprehensive-process-title-provide:Provide`,
            subtitle: $localize`:@@comprehensive-process-subtitle-provide:Provide customizable notifications for tasks, project updates, financial milestones, and more`,
        },
        {
            imgPath: 'timer-desktop',
            title: $localize`:@@comprehensive-process-title-ensure:Ensure`,
            subtitle: $localize`:@@comprehensive-process-subtitle-ensure:Ensure that users receive timely alerts for overdue tasks and upcoming deadlines`,
        },
        {
            imgPath: 'chat-check',
            title: $localize`:@@comprehensive-process-title-multi:Multi-channel`,
            subtitle: $localize`:@@comprehensive-process-subtitle-multi:Offer multi-channel notifications, including email, in-app alerts, and SMS`,
        },
    ];
}
